import { PatternMatch } from "project-config/utils/pattern-match";

export function useFuzzySearch(tableData: any[], key: string) {
  function fuzzySearch(searchInput: string) {
    const _result = tableData.filter((item) =>
      PatternMatch.fuzzyMatch(item[key], searchInput)
    );
    return _result;
  }

  return {
    fuzzySearch,
  };
}
